import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { Link, withRouter, matchPath } from "react-router-dom";
import {
  SITENAMEALIAS,
  ASSETS,
  FILEPATH,
  PAYMENTURLFORHOSTEDCATALOG,
} from "../utils/init";
import {
  showToast,
  showHttpError,
  handleCurrencyDetiails,
  handleDynamicCurrencyDetiails,
  showConfirm,
  handleNetworkDetails,
  initialiseNetwork,
  getCurrencyWiseTxnCharge,
} from "../utils/library";
import {
  AddNewHostedCatalog,
  GetHostedCatalog,
  UpdateHostedCatalog,
  GetMerchantSettings,
  GetMarketPrice,
  FetchUsdBtcLedgerAmount,
} from "../utils/service";
import { QRCodeSVG } from "qrcode.react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const styles = {
  pageWrapper: { padding: "36px 24px 60px" },
  backRow: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "28px",
  },
  backBtn: {
    width: "38px",
    height: "38px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color-less)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "var(--text-color)",
    fontSize: "15px",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  pageSubtitle: { fontSize: "13px", opacity: 0.5, margin: "4px 0 0" },
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    marginBottom: "24px",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "20px 28px",
    borderBottom: "1px solid var(--body-color-less2)",
  },
  cardHeaderIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
  },
  cardHeaderTitle: {
    fontSize: "16px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  cardBody: { padding: "24px 28px" },
  formGroup: { display: "flex", flexDirection: "column", gap: "6px" },
  label: {
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    color: "var(--text-color)",
    opacity: 0.7,
  },
  input: {
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  },
  inputDisabled: {
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    opacity: 0.6,
    cursor: "not-allowed",
  },
  select: {
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    appearance: "auto",
  },
  inputWithSuffix: { position: "relative" },
  inputSuffix: {
    position: "absolute",
    right: "14px",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: "12px",
    fontWeight: "600",
    color: "var(--text-color)",
    opacity: 0.4,
    pointerEvents: "none",
  },
  errorText: { fontSize: "11px", color: "#ef4444", marginTop: "2px" },
  checkboxRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "6px 0",
  },
  checkbox: {
    width: "16px",
    height: "16px",
    accentColor: "var(--btn-color)",
    cursor: "pointer",
    flexShrink: 0,
  },
  checkboxDisabled: {
    width: "16px",
    height: "16px",
    accentColor: "var(--btn-color)",
    flexShrink: 0,
    cursor: "not-allowed",
  },
  checkboxLabel: {
    fontSize: "13px",
    fontWeight: "500",
    color: "var(--text-color)",
  },
  customFieldRow: { display: "flex", alignItems: "center", gap: "10px" },
  removeFieldBtn: {
    width: "32px",
    height: "32px",
    borderRadius: "8px",
    border: "none",
    background: "rgba(239,68,68,0.1)",
    color: "#ef4444",
    fontSize: "13px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  addFieldBtn: {
    padding: "8px 18px",
    background: "transparent",
    border: "1px dashed var(--body-color-less2)",
    borderRadius: "10px",
    color: "var(--btn-color)",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    marginTop: "4px",
  },
  btnPrimary: {
    padding: "11px 32px",
    background: "var(--btn-color)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    letterSpacing: "0.3px",
  },
  tipCard: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 8%, transparent), color-mix(in srgb, var(--btn-color) 3%, transparent))",
    border: "1px solid color-mix(in srgb, var(--btn-color) 15%, transparent)",
    borderRadius: "12px",
    padding: "20px 24px",
    marginBottom: "24px",
  },
  tipItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "13px",
    lineHeight: "1.6",
    color: "var(--text-color)",
    marginBottom: "10px",
  },
  tipIcon: { color: "var(--btn-color)", fontSize: "13px", flexShrink: 0 },
  sectionDivider: {
    borderTop: "1px solid var(--body-color-less2)",
    margin: "8px 0",
  },
  buttonSizeOptions: { display: "flex", gap: "10px", flexWrap: "wrap" },
  sizeBtn: {
    padding: "8px 18px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
  },
  sizeBtnActive: {
    padding: "8px 18px",
    borderRadius: "10px",
    border: "1px solid var(--btn-color)",
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 12%, transparent), color-mix(in srgb, var(--btn-color) 4%, transparent))",
    color: "var(--btn-color)",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
  },
  codeArea: {
    width: "100%",
    minHeight: "120px",
    padding: "14px 16px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "12px",
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    resize: "vertical",
    outline: "none",
    boxSizing: "border-box",
  },
  copyBtn: {
    padding: "7px 16px",
    borderRadius: "8px",
    border: "1px solid var(--btn-color)",
    background: "transparent",
    color: "var(--btn-color)",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
  },
  paymentLinkBox: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
  },
  paymentLinkInput: {
    flex: 1,
    border: "none",
    background: "transparent",
    fontSize: "13px",
    color: "var(--text-color)",
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    outline: "none",
    width: "100%",
  },
  previewBox: {
    padding: "24px",
    borderRadius: "10px",
    border: "1px dashed var(--body-color-less2)",
    background: "var(--body-color)",
    textAlign: "center",
    minHeight: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  previewPlaceholder: {
    fontSize: "13px",
    color: "var(--text-color)",
    opacity: 0.4,
  },
  tabContainer: {
    display: "flex",
    background: "var(--body-color)",
    borderRadius: "12px",
    padding: "4px",
    border: "1px solid var(--body-color-less2)",
    marginBottom: "16px",
    gap: "4px",
  },
  tab: {
    flex: 1,
    padding: "10px 16px",
    borderRadius: "9px",
    border: "none",
    background: "transparent",
    color: "var(--text-color)",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "all 0.2s ease",
    opacity: 0.6,
  },
  tabActive: {
    flex: 1,
    padding: "10px 16px",
    borderRadius: "9px",
    border: "none",
    background: "var(--btn-color)",
    color: "#fff",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  },
  tabContent: { padding: "16px 0 0" },
  paymentLinkCard: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    marginBottom: "24px",
    padding: "24px 28px",
  },
};

class EditHostedCatalogItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hostedCatalogId: "",
      showLoader: false,
      isCheckedClickToPayUri: true,
      isCheckedScanToPayQr: true,
      isCheckedCopyPastePaymentMethod: true,
      selectedAsset: {},
      selectedButtonSize: "",
      activeGenerateTab: "button",
      usdPrice: "",
      buttonHtml: "",
      hyperLinkHtml: "",
      qrCodeLink: "",
      sku: "",
      customField1: { name: 1, value: "", status: 0 },
      customField2: { name: 2, value: "", status: 0 },
      customField3: { name: 3, value: "", status: 0 },
      isBuyerEmailChecked: true,
      isBuyerFullNameChecked: true,
      isBuyerAddressChecked: false,
      isBuyerPhoneChecked: false,
      isCryptoRefundAddressChecked: false,
      validUsdPrice: false,
      networkArray: [],
      assets: [],
      network: "",
      processingFeeHandling: "customer",
      // ── txn charge for selected currency ──
      txnCharge: null,
    };

    this.merchantNameRef = React.createRef();
    this.descriptionRef = React.createRef();
    this.skuRef = React.createRef();
    this.itemPriceRef = React.createRef();
    this.shippingRef = React.createRef();
    this.taxRef = React.createRef();
  }

  handleBack = () => {
    this.props.history.goBack();
  };

  // ── Fetch txn charge for the given asset code and store in state ──
  fetchTxnCharge = async (assetCode) => {
    const charge = await getCurrencyWiseTxnCharge(assetCode);
    this.setState({ txnCharge: charge });
  };

  handleAddCustomFields = () => {
    if (this.state.customField1.status == 0) {
      this.setState({ customField1: { name: 1, value: "", status: 1 } });
    } else if (this.state.customField2.status == 0) {
      this.setState({ customField2: { name: 2, value: "", status: 1 } });
    } else {
      this.setState({ customField3: { name: 3, value: "", status: 1 } });
    }
  };

  handleRemoveCustomField = (fieldNumber) => {
    const { customField1, customField2, customField3 } = this.state;
    let fields = [];
    if (customField1.status == 1 && fieldNumber != 1)
      fields.push(customField1.value);
    if (customField2.status == 1 && fieldNumber != 2)
      fields.push(customField2.value);
    if (customField3.status == 1 && fieldNumber != 3)
      fields.push(customField3.value);
    this.setState({
      customField1:
        fields.length >= 1
          ? { name: 1, value: fields[0], status: 1 }
          : { name: 1, value: "", status: 0 },
      customField2:
        fields.length >= 2
          ? { name: 2, value: fields[1], status: 1 }
          : { name: 2, value: "", status: 0 },
      customField3:
        fields.length >= 3
          ? { name: 3, value: fields[2], status: 1 }
          : { name: 3, value: "", status: 0 },
    });
  };

  handleSetCustomFieldValue = (fieldName, param) => {
    let field = "";
    if (fieldName == 1) {
      field = "customField1";
      this.setState({ customField1: { name: field, value: param, status: 1 } });
    } else if (fieldName == 2) {
      field = "customField2";
      this.setState({ customField2: { name: field, value: param, status: 1 } });
    } else {
      field = "customField3";
      this.setState({ customField3: { name: field, value: param, status: 1 } });
    }
  };

  handleBuyersName = () => {
    this.setState({
      isBuyerFullNameChecked: !this.state.isBuyerFullNameChecked,
    });
  };

  handleBuyersAddress = () => {
    this.setState({ isBuyerAddressChecked: !this.state.isBuyerAddressChecked });
  };

  handleBuyerPhone = () => {
    this.setState({ isBuyerPhoneChecked: !this.state.isBuyerPhoneChecked });
  };

  handleCryptoRefundAddress = () => {
    this.setState({
      isCryptoRefundAddressChecked: !this.state.isCryptoRefundAddressChecked,
    });
  };

  handleUpdateHostedCatalog = () => {
    this.setState({ showLoader: true });
    let payload = {
      merchant_id: parseInt(
        localStorage.getItem(SITENAMEALIAS + "_merchant_id")
      ),
      hosted_catalog_id: this.state.hostedCatalogId,
      collect_email: 1,
      currency_id: this.state.selectedAsset.assetId,
      description: this.descriptionRef.current.value,
      item_number: this.skuRef.current.value,
      item_price: this.itemPriceRef.current.value,
      merchant_name: this.merchantNameRef.current.value,
      shipping_handling: this.shippingRef.current.value,
      tax_rate: this.taxRef.current.value,
      fiat_price: this.state.usdPrice,
      network: this.state.network,
      is_processing_fee_applied:
        this.state.processingFeeHandling === "customer" ? 1 : 0,
    };
    if (this.state.isBuyerAddressChecked == true) {
      console.log("buyer address checked");
      payload["collect_address"] = 1;
    } else {
      payload["collect_address"] = 0;
    }
    payload["collect_full_name"] = 1;
    if (this.state.isBuyerPhoneChecked == true) {
      console.log("phone number checked");
      payload["collect_phone"] = 1;
    } else {
      payload["collect_phone"] = 0;
    }
    if (this.state.isCryptoRefundAddressChecked == true) {
      payload["collect_refund_address"] = 1;
    } else {
      payload["collect_refund_address"] = 0;
    }
    if (this.state.customField1.status == 1) {
      payload["collect_custom_1"] = 1;
      payload["custom_field_1"] = this.state.customField1.value;
    } else {
      payload["collect_custom_1"] = 0;
      payload["custom_field_1"] = "";
    }
    if (this.state.customField2.status == 1) {
      payload["collect_custom_2"] = 1;
      payload["custom_field_2"] = this.state.customField2.value;
    } else {
      payload["collect_custom_2"] = 0;
      payload["custom_field_2"] = "";
    }
    if (this.state.customField3.status == 1) {
      payload["collect_custom_3"] = 1;
      payload["custom_field_3"] = this.state.customField3.value;
    } else {
      payload["collect_custom_3"] = 0;
      payload["custom_field_3"] = "";
    }
    this.setState({ showLoader: false });
    UpdateHostedCatalog(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let errorObj = response[response.length - 1];
          if (errorObj.error != "0") {
            showToast("error", errorObj.error_msg);
          } else {
            this.renderHostedCatalogItemData(this.state.hostedCatalogId);
            showToast("success", "Hosted Catelog Items updated successfully");
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleSelectedCurrency = (e) => {
    let code = e.target.value;
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      currency_id: code,
    };
    this.setState({ showLoader: true });
    GetMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (
              response.accept_overpayments != "" &&
              response.accept_overpayments != null &&
              response.accept_overpayments != "no" &&
              response.accept_underpayments != "" &&
              response.accept_underpayments != null &&
              response.accept_underpayments != "no"
            ) {
              const newAsset = handleDynamicCurrencyDetiails(
                this.state.assets,
                code
              );
              if (this.itemPriceRef.current) {
                this.itemPriceRef.current.value = "";
              }
              this.setState(
                {
                  selectedAsset: newAsset,
                  networkArray: newAsset.network,
                  network: newAsset.network[0],
                },
                () => {
                  this.getConvertedPrice();
                  // ── Refresh txn charge for newly selected currency ──
                  this.fetchTxnCharge(newAsset.assetCode);
                }
              );
            } else {
              showConfirm(
                "Set your underpayment or overpayment tolerance limits",
                "Go to Merchant Settings > Automatic Exception Handling",
                "error",
                () => {
                  localStorage.setItem(
                    SITENAMEALIAS + "_need_tolerance_setting",
                    "true"
                  );
                  localStorage.setItem(
                    SITENAMEALIAS + "_need_tolerance_setting_for_currency",
                    code
                  );
                  this.props.history.push("/settings");
                }
              );
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleNetworkChange = (e) => {
    this.setState({ network: e.target.value }, () => {
      if (this.state.usdPrice && this.state.selectedAsset.assetCode) {
        if (this.itemPriceRef.current) {
          this.itemPriceRef.current.value = "";
        }
        this.getConvertedPrice();
      }
    });
  };

  renderHostedCatalogItemData = (id) => {
    let payload = {
      hosted_catalog_id: id,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    GetHostedCatalog(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          console.log("no error");
          this.descriptionRef.current.value = response.ITEM_DESCRIPTION;
          this.itemPriceRef.current.value = response.ITEM_PRICE;
          if (
            response.ITEM_NUMBER != undefined &&
            response.ITEM_NUMBER != null
          ) {
            this.skuRef.current.value = response.ITEM_NUMBER;
          } else {
            this.skuRef.current.value = "";
          }
          this.merchantNameRef.current.value = response.MERCHANT_NAME;
          this.shippingRef.current.value = response.ITEM_SHIPPING_HANDLING;
          this.taxRef.current.value = response.ITEM_TAX;

          this.setState(
            {
              usdPrice: parseFloat(response.FIAT_PRICE).toFixed(2),
              validUsdPrice: true,
            },
            () => {
              document.getElementById("usdPriceField").value =
                this.state.usdPrice;
            }
          );

          if (response.COLLECT_ADDRESS === 1) {
            this.setState({ isBuyerAddressChecked: true });
          } else {
            this.setState({ isBuyerAddressChecked: false });
          }
          if (response.COLLECT_PHONE_NUMBER === 1) {
            this.setState({ isBuyerPhoneChecked: true });
          } else {
            this.setState({ isBuyerPhoneChecked: false });
          }
          if (response.COLLECT_REFUND_ADDRESS === 1) {
            this.setState({ isCryptoRefundAddressChecked: true });
          } else {
            this.setState({ isCryptoRefundAddressChecked: false });
          }

          // Restore processing fee selection from API
          const restoredFeeHandling =
            parseInt(response.IS_PROCESSING_FEE_APPLIED) === 1
              ? "customer"
              : "merchant";
          this.setState({ processingFeeHandling: restoredFeeHandling });

          const restoredAsset = handleDynamicCurrencyDetiails(
            this.state.assets,
            response.CURRENCY_ID
          );
          this.setState(
            {
              showPreviewForButton: false,
              showPreviewForHyperlink: false,
              showPreviewForQrCode: false,
              buttonImageUrl: "",
              encodedValue: "",
              previewFormAction: "",
              selectedAsset: restoredAsset,
              networkArray: restoredAsset.network,
              network: response.NETWORK,
            },
            () => {
              console.log("NETWORK", this.state.network);
              // ── Fetch txn charge for the restored currency ──
              this.fetchTxnCharge(restoredAsset.assetCode);
            }
          );

          if (response.COLLECT_CUSTOM_1 == 1) {
            this.setState({
              customField1: {
                name: 1,
                value: response.CUSTOM_FIELD_1,
                status: response.COLLECT_CUSTOM_1,
              },
            });
          } else {
            this.setState({ customField1: { name: 1, value: "", status: 0 } });
          }
          if (response.COLLECT_CUSTOM_2 == "1") {
            this.setState({
              customField2: {
                name: 2,
                value: response.CUSTOM_FIELD_2,
                status: response.COLLECT_CUSTOM_2,
              },
            });
          } else {
            this.setState({ customField2: { name: 2, value: "", status: 0 } });
          }
          if (response.COLLECT_CUSTOM_3 == "1") {
            this.setState({
              customField3: {
                name: 3,
                value: response.CUSTOM_FIELD_3,
                status: response.COLLECT_CUSTOM_3,
              },
            });
          } else {
            this.setState({ customField3: { name: 3, value: "", status: 0 } });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  copyCodeToClipboard = () => {
    const el = this.textArea;
    el.select();
    document.execCommand("copy");
    showToast("success", " Successfully copied to clipboard");
  };

  getPaymentLink = () => {
    return (
      PAYMENTURLFORHOSTEDCATALOG +
      "?hosted_catalog_id=" +
      btoa(this.state.hostedCatalogId)
    );
  };

  copyLinkToClipboard = () => {
    const link = this.getPaymentLink();
    navigator.clipboard
      .writeText(link)
      .then(() => {
        showToast("success", "Payment link copied to clipboard");
      })
      .catch(() => {
        const tempInput = document.createElement("input");
        tempInput.value = link;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
        showToast("success", "Payment link copied to clipboard");
      });
  };

  generateHyperLink = () => {
    let html =
      '<a href="' +
      PAYMENTURLFORHOSTEDCATALOG +
      "?hosted_catalog_id=" +
      btoa(this.state.hostedCatalogId) +
      '" target="_blank">Order Now</a>';
    this.setState({
      buttonHtml: html,
      hyperLinkHtml: "",
      showPreviewForButton: false,
      showPreviewForHyperlink: true,
      showPreviewForQrCode: false,
      buttonImageUrl: "",
      encodedValue: btoa(this.state.hostedCatalogId),
      previewFormAction: PAYMENTURLFORHOSTEDCATALOG,
    });
  };

  generateQrCode = () => {
    let url =
      PAYMENTURLFORHOSTEDCATALOG +
      "?hosted_catalog_id=" +
      btoa(this.state.hostedCatalogId);
    this.setState(
      {
        buttonHtml: "",
        qrCodeLink: url,
        showPreviewForButton: false,
        showPreviewForHyperlink: false,
        showPreviewForQrCode: true,
        buttonImageUrl: "",
      },
      () => {
        let element = document.getElementById("qrCodeHtml").innerHTML;
        this.setState({ buttonHtml: element });
      }
    );
  };

  handleGenerateButton = (size) => {
    let imageText = "",
      buttonStyle = "",
      buttonImageStyle = "",
      buttonTextStyle = "";
    if (size == "small") {
      imageText = "sm-button-";
      buttonStyle = "width:80px;height:43px;";
      buttonImageStyle = "width:16px;";
      buttonTextStyle = "font-size:10px;";
    } else if (size == "medium") {
      imageText = "md-button-";
      buttonStyle = "width:105px;height:56px;";
      buttonImageStyle = "width:33px;";
      buttonTextStyle = "font-size:12px;";
    } else {
      imageText = "lg-button-";
      buttonStyle = "width:132px;height:70px;";
      buttonImageStyle = "width:40px;";
      buttonTextStyle = "font-size:12px;";
    }
    let html =
      ' <div style="display:block;" id="paynow_button_form_container">';
    html +=
      '<form method="GET" action="' +
      PAYMENTURLFORHOSTEDCATALOG +
      '" target="_blank">';
    html +=
      '<input type="hidden" name="hosted_catalog_id" id="hosted_catalog_id" value="' +
      btoa(this.state.hostedCatalogId) +
      '"/>';
    html += '<table border="0"><tbody><tr>';
    html +=
      '<td style="padding:5px;" align="center" valign="middle"><button style="padding:0; border:0;background : #102ab3;color:#fff; ' +
      buttonStyle +
      '" type="submit" ><img  src="' +
      this.assetDetailsForButtons(this.state.selectedAsset.assetId).assetImage +
      '" style="' +
      buttonImageStyle +
      '"/> <span style="' +
      buttonTextStyle +
      '">Buy Now</span></button></td>';
    html += "</tr></tbody></table></form></div>";
    this.setState({
      buttonHtml: html,
      hyperLinkHtml: "",
      showPreviewForButton: true,
      selectedButtonSize: size,
      showPreviewForHyperlink: false,
      showPreviewForQrCode: false,
      buttonImageUrl:
        FILEPATH +
        "/" +
        imageText +
        this.state.selectedAsset.assetCode +
        ".png",
      encodedValue: btoa(this.state.hostedCatalogId),
      previewFormAction: PAYMENTURLFORHOSTEDCATALOG,
    });
  };

  getConvertedPrice = () => {
    let currency = this.state.selectedAsset.assetCode;
    this.setState({ showLoader: true });
    GetMarketPrice(currency)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let price = response.price;
          let convertedPrice =
            parseFloat(this.state.usdPrice) / parseFloat(price);
          this.itemPriceRef.current.value = convertedPrice.toFixed(6);
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
        }.bind(this)
      );
  };

  reverseConversation = () => {
    let currency = this.state.selectedAsset.assetCode;
    this.setState({ showLoader: true });
    GetMarketPrice(currency)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let price = response.price;
          let convertedPrice =
            parseFloat(price) * parseFloat(this.itemPriceRef.current.value);
          this.setState(
            { usdPrice: convertedPrice.toFixed(2), validUsdPrice: true },
            () => {
              document.getElementById("usdPriceField").value =
                this.state.usdPrice;
            }
          );
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
        }.bind(this)
      );
  };

  handleRenderAssets = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    FetchUsdBtcLedgerAmount(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          console.log(response);
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response != undefined && response != null) {
              let coinBalance = response.coin_balance;
              let arr = [];
              if (coinBalance != undefined) {
                for (let i = 0; i < coinBalance.length; i++) {
                  if (coinBalance[i].currency_code != "USD") {
                    arr.push({
                      assetName: coinBalance[i].currency_name,
                      coinBalance: coinBalance[i].balance,
                      assetCode: coinBalance[i].currency_code,
                      assetId: coinBalance[i].currency_id,
                      assetImage: coinBalance[i].logo,
                      network: coinBalance[i].network,
                      isBrokerCurrency: coinBalance[i].is_broker_currency,
                    });
                  }
                }
              }
              const currencyOrder = ['USDC', 'USDT', 'XRP', 'DOGE', 'HCX', 'ETH', 'BTC', 'LTC', 'BCH'];
              arr.sort((a, b) => {
                const idxA = currencyOrder.indexOf(a.assetCode);
                const idxB = currencyOrder.indexOf(b.assetCode);
                return (idxA === -1 ? 999 : idxA) - (idxB === -1 ? 999 : idxB);
              });
              this.setState({ assets: arr }, () => {
                console.log(this.state.assets);
                localStorage.setItem(
                  SITENAMEALIAS + "_assets",
                  JSON.stringify(this.state.assets)
                );
                this.renderHostedCatalogItemData(this.state.hostedCatalogId);
              });
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  assetDetailsForButtons = (assetId) => {
    let assets = this.state.assets;
    let result = {};
    for (let i = 0; i < assets.length; i++) {
      if (assetId == assets[i].assetId) {
        result = assets[i];
        break;
      }
    }
    return result;
  };

  componentDidMount() {
    this.handleRenderAssets();
    const match = matchPath(this.props.history.location.pathname, {
      path: "/edit-hosted-catalog-item/:param1",
      exact: true,
      strict: false,
    });
    this.setState({
      hostedCatalogId: match.params.param1,
      selectedAsset: handleCurrencyDetiails(2),
      networkArray: handleNetworkDetails(2),
      network: initialiseNetwork(2),
    });
    // Note: txnCharge for the actual saved currency is fetched in
    // renderHostedCatalogItemData once the API response is loaded.
  }

  renderCustomField(fieldNum, fieldState) {
    if (fieldState.status != 1) return null;
    return (
      <div style={{ ...styles.formGroup, marginTop: "4px" }} key={fieldNum}>
        <label style={styles.label}>Custom Field {fieldNum}</label>
        <div style={styles.customFieldRow}>
          <input
            type="text"
            style={{ ...styles.input, flex: 1 }}
            onChange={(e) =>
              this.handleSetCustomFieldValue(fieldNum, e.target.value)
            }
            value={fieldState.value}
            placeholder={`Enter custom field ${fieldNum} label`}
          />
          <button
            type="button"
            style={styles.removeFieldBtn}
            onClick={() => this.handleRemoveCustomField(fieldNum)}
          >
            <i className="fa fa-trash" />
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { processingFeeHandling, txnCharge, selectedAsset } = this.state;

    // ── Fee label for radio descriptions ──
    const feeLabel = txnCharge != null ? `${txnCharge} fee` : "processing fee";
    const currencyLabel = selectedAsset.assetCode
      ? ` for ${selectedAsset.assetCode}`
      : "";

    const feeOptionStyle = (val) => ({
      flex: 1,
      display: "flex",
      alignItems: "flex-start",
      gap: "8px",
      padding: "8px 12px",
      borderRadius: "10px",
      border:
        processingFeeHandling === val
          ? "1.5px solid var(--btn-color)"
          : "1.5px solid var(--body-color-less2)",
      background:
        processingFeeHandling === val
          ? "color-mix(in srgb, var(--btn-color), transparent 93%)"
          : "var(--body-color)",
      cursor: "pointer",
      userSelect: "none",
      transition: "all 0.15s ease",
    });

    const radioDotStyle = (val) => ({
      width: "15px",
      height: "15px",
      borderRadius: "50%",
      border:
        processingFeeHandling === val
          ? "5px solid var(--btn-color)"
          : "2px solid color-mix(in srgb, var(--text-color), transparent 55%)",
      background: "var(--body-color)",
      flexShrink: 0,
      marginTop: "2px",
      transition: "all 0.15s ease",
    });

    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={styles.pageWrapper}>
              {/* Back + Title */}
              <div style={styles.backRow}>
                <div style={styles.backBtn} onClick={this.handleBack}>
                  <FontAwesomeIcon icon={faArrowLeft} />
                </div>
                <div>
                  <h2 style={styles.pageTitle}>Edit a Checkout Page</h2>
                  <div style={styles.pageSubtitle}>
                    Update your checkout details and regenerate embed codes
                  </div>
                </div>
              </div>

              {/* Info Tips */}
              <div style={styles.tipCard}>
                <div style={styles.tipItem}>
                  <i className="fa fa-check-circle" style={styles.tipIcon} />
                  <span>
                    This form will create the HTML code or a scannable barcode
                    that you can add to your website or printed materials.
                  </span>
                </div>
                <div style={styles.tipItem}>
                  <i className="fa fa-check-circle" style={styles.tipIcon} />
                  <span>
                    This button will submit the item information and price.
                    Blockchain manages the shopping cart and collects the buyers
                    name and address if necessary.
                  </span>
                </div>
                <div style={{ ...styles.tipItem, marginBottom: 0 }}>
                  <i className="fa fa-check-circle" style={styles.tipIcon} />
                  <span>
                    When the transaction is completed, both the buyer and seller
                    will receive an email order confirmation.
                  </span>
                </div>
              </div>

              {/* Two Column Layout */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "24px",
                }}
              >
                {/* Left - Item Details Card */}
                <div style={styles.card}>
                  <div style={styles.cardHeader}>
                    <div
                      style={{
                        ...styles.cardHeaderIcon,
                        background:
                          "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 15%, transparent), color-mix(in srgb, var(--btn-color) 5%, transparent))",
                        color: "var(--btn-color)",
                      }}
                    >
                      <i className="mdi mdi-package-variant" />
                    </div>
                    <h4 style={styles.cardHeaderTitle}>Item Details</h4>
                  </div>
                  <div style={styles.cardBody}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "18px",
                      }}
                    >
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Merchant Name *</label>
                        <input
                          type="text"
                          style={styles.input}
                          ref={this.merchantNameRef}
                          placeholder="Enter merchant name"
                        />
                      </div>

                      <div style={styles.formGroup}>
                        <label style={styles.label}>Item Description *</label>
                        <input
                          type="text"
                          style={styles.input}
                          ref={this.descriptionRef}
                          placeholder="Enter item description"
                        />
                      </div>

                      <div style={styles.formGroup}>
                        <label style={styles.label}>
                          Item Number / SKU (Optional)
                        </label>
                        <input
                          type="text"
                          style={styles.input}
                          ref={this.skuRef}
                          placeholder="Enter item number/SKU"
                        />
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "16px",
                        }}
                      >
                        <div style={styles.formGroup}>
                          <label style={styles.label}>Currency</label>
                          <select
                            style={styles.select}
                            onChange={(e) => this.handleSelectedCurrency(e)}
                            defaultValue={this.state.selectedAsset.assetId}
                          >
                            {this.state.assets.map((item) => (
                              <option
                                key={item.assetId}
                                value={item.assetId}
                                selected={
                                  item.assetId ==
                                  this.state.selectedAsset.assetId
                                }
                              >
                                {item.assetCode} - {item.assetName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div style={styles.formGroup}>
                          <label style={styles.label}>Network</label>
                          {this.state.networkArray.length > 1 ? (
                            <select
                              style={styles.select}
                              onChange={(e) => this.handleNetworkChange(e)}
                              value={this.state.network}
                            >
                              {this.state.networkArray.map((network) => (
                                <option key={network} value={network}>
                                  {network}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <input
                              type="text"
                              style={styles.select}
                              value={this.state.networkArray[0] || ""}
                              disabled
                            />
                          )}
                        </div>
                      </div>

                      {/* Item Price */}
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Item Price ($) *</label>
                        <div style={styles.inputWithSuffix}>
                          <input
                            type="number"
                            style={{ ...styles.input, paddingRight: "50px" }}
                            id="usdPriceField"
                            onKeyUp={(e) => {
                              if (e.target.value != "") {
                                this.setState(
                                  {
                                    usdPrice: e.target.value,
                                    validUsdPrice: true,
                                  },
                                  () => {
                                    this.getConvertedPrice();
                                  }
                                );
                              } else {
                                this.setState({
                                  usdPrice: "",
                                  validUsdPrice: false,
                                });
                              }
                            }}
                            placeholder="Enter item price"
                          />
                          <span style={styles.inputSuffix}>USD</span>
                        </div>
                        {!this.state.validUsdPrice && (
                          <span style={styles.errorText}>
                            Please insert valid data
                          </span>
                        )}
                      </div>

                      {/* ── Processing Fee Handling ── */}
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Processing Fee</label>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={feeOptionStyle("customer")}
                            onClick={() =>
                              this.setState({
                                processingFeeHandling: "customer",
                              })
                            }
                          >
                            <div style={radioDotStyle("customer")} />
                            <div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  color: "var(--text-color)",
                                  lineHeight: "1.3",
                                }}
                              >
                                Customer pays fee
                              </div>
                              {txnCharge != null && (
                                <div
                                  style={{
                                    fontSize: "11px",
                                    color: "var(--text-color)",
                                    opacity: 0.5,
                                    marginTop: "2px",
                                  }}
                                >
                                  {feeLabel}
                                  {currencyLabel} added to total
                                </div>
                              )}
                            </div>
                          </div>
                          <div
                            style={feeOptionStyle("merchant")}
                            onClick={() =>
                              this.setState({
                                processingFeeHandling: "merchant",
                              })
                            }
                          >
                            <div style={radioDotStyle("merchant")} />
                            <div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  color: "var(--text-color)",
                                  lineHeight: "1.3",
                                }}
                              >
                                Merchant absorbs fee
                              </div>
                              {txnCharge != null && (
                                <div
                                  style={{
                                    fontSize: "11px",
                                    color: "var(--text-color)",
                                    opacity: 0.5,
                                    marginTop: "2px",
                                  }}
                                >
                                  {feeLabel}
                                  {currencyLabel} deducted from payout
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* ── End Processing Fee Handling ── */}

                      {/* Crypto Price */}
                      <div style={styles.formGroup}>
                        <label style={styles.label}>
                          Crypto Price{" "}
                          <span
                            className="tooltip-container"
                            style={{
                              position: "relative",
                              display: "inline-flex",
                              marginLeft: "4px",
                              cursor: "help",
                            }}
                          >
                            <i
                              className="fa fa-info-circle info-icon"
                              style={{ fontSize: "11px", opacity: 0.5 }}
                            ></i>
                            <span
                              className="tooltip-text"
                              style={{ textAlign: "justify" }}
                            >
                              The amount in crypto shown here is indicative.
                              When the payment is actually made, the system will
                              check the market price of crypto at that time and
                              deduct the equivalent amount.
                            </span>
                          </span>
                        </label>
                        <div style={styles.inputWithSuffix}>
                          <input
                            type="number"
                            style={{
                              ...styles.inputDisabled,
                              paddingRight: "60px",
                            }}
                            ref={this.itemPriceRef}
                            placeholder="Auto-calculated"
                            disabled
                          />
                          <span style={styles.inputSuffix}>
                            {this.state.selectedAsset.assetCode}
                          </span>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "16px",
                        }}
                      >
                        <div style={styles.formGroup}>
                          <label style={styles.label}>
                            Shipping & Handling (%)
                          </label>
                          <input
                            type="number"
                            style={styles.input}
                            ref={this.shippingRef}
                            placeholder="0.00"
                          />
                        </div>
                        <div style={styles.formGroup}>
                          <label style={styles.label}>Tax Rate (%)</label>
                          <input
                            type="number"
                            style={styles.input}
                            ref={this.taxRef}
                            placeholder="0.00"
                          />
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "4px",
                        }}
                      >
                        <button
                          type="button"
                          style={styles.btnPrimary}
                          onClick={this.handleUpdateHostedCatalog}
                        >
                          Update Item
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right - Buyer Info & Custom Fields Card */}
                <div>
                  <div style={styles.card}>
                    <div style={styles.cardHeader}>
                      <div
                        style={{
                          ...styles.cardHeaderIcon,
                          background:
                            "linear-gradient(135deg, color-mix(in srgb, #8b5cf6 15%, transparent), color-mix(in srgb, #8b5cf6 5%, transparent))",
                          color: "#8b5cf6",
                        }}
                      >
                        <i className="mdi mdi-account-check-outline" />
                      </div>
                      <h4 style={styles.cardHeaderTitle}>
                        Buyer Data Collection
                      </h4>
                    </div>
                    <div style={styles.cardBody}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "6px",
                          marginBottom: "20px",
                        }}
                      >
                        <div style={styles.checkboxRow}>
                          <input
                            type="checkbox"
                            style={styles.checkboxDisabled}
                            checked={this.state.isBuyerEmailChecked}
                            disabled
                          />
                          <span style={styles.checkboxLabel}>
                            Collect Buyer's Email Address{" "}
                            <span style={{ fontSize: "11px", opacity: 0.5 }}>
                              (required)
                            </span>
                          </span>
                        </div>
                        <div style={styles.checkboxRow}>
                          <input
                            type="checkbox"
                            style={styles.checkboxDisabled}
                            checked={this.state.isBuyerFullNameChecked}
                            disabled
                          />
                          <span style={styles.checkboxLabel}>
                            Collect Buyer's Full Name{" "}
                            <span style={{ fontSize: "11px", opacity: 0.5 }}>
                              (required)
                            </span>
                          </span>
                        </div>
                        <div style={styles.checkboxRow}>
                          <input
                            type="checkbox"
                            style={styles.checkbox}
                            checked={this.state.isBuyerAddressChecked}
                            onChange={this.handleBuyersAddress}
                          />
                          <span style={styles.checkboxLabel}>
                            Collect Buyer's Address
                          </span>
                        </div>
                        <div style={styles.checkboxRow}>
                          <input
                            type="checkbox"
                            style={styles.checkbox}
                            checked={this.state.isBuyerPhoneChecked}
                            onChange={this.handleBuyerPhone}
                          />
                          <span style={styles.checkboxLabel}>
                            Collect Buyer's Telephone Number
                          </span>
                        </div>
                        <div style={styles.checkboxRow}>
                          <input
                            type="checkbox"
                            style={styles.checkbox}
                            checked={this.state.isCryptoRefundAddressChecked}
                            onChange={this.handleCryptoRefundAddress}
                          />
                          <span style={styles.checkboxLabel}>
                            Ask for Crypto Refund Address{" "}
                            <span style={{ fontSize: "11px", opacity: 0.5 }}>
                              (optional for buyers)
                            </span>
                          </span>
                        </div>
                      </div>

                      <div style={styles.sectionDivider} />

                      <div style={{ marginTop: "16px" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "12px",
                          }}
                        >
                          <label style={{ ...styles.label, margin: 0 }}>
                            Custom Fields
                          </label>
                          {(this.state.customField1.status == 0 ||
                            this.state.customField2.status == 0 ||
                            this.state.customField3.status == 0) && (
                            <button
                              type="button"
                              style={styles.addFieldBtn}
                              onClick={this.handleAddCustomFields}
                            >
                              <i className="mdi mdi-plus" /> Add Field
                            </button>
                          )}
                        </div>
                        {this.renderCustomField(1, this.state.customField1)}
                        {this.renderCustomField(2, this.state.customField2)}
                        {this.renderCustomField(3, this.state.customField3)}
                        {this.state.customField1.status == 0 &&
                          this.state.customField2.status == 0 &&
                          this.state.customField3.status == 0 && (
                            <div
                              style={{
                                fontSize: "13px",
                                color: "var(--text-color)",
                                opacity: 0.4,
                                padding: "8px 0",
                              }}
                            >
                              No custom fields added yet
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Payment Link Card */}
              <div style={styles.paymentLinkCard}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "16px",
                  }}
                >
                  <div
                    style={{
                      ...styles.cardHeaderIcon,
                      background:
                        "linear-gradient(135deg, color-mix(in srgb, #f59e0b 15%, transparent), color-mix(in srgb, #f59e0b 5%, transparent))",
                      color: "#f59e0b",
                    }}
                  >
                    <i className="mdi mdi-link-variant" />
                  </div>
                  <h4 style={styles.cardHeaderTitle}>Payment Link</h4>
                </div>
                <div style={styles.paymentLinkBox}>
                  <input
                    type="text"
                    style={styles.paymentLinkInput}
                    value={
                      this.state.hostedCatalogId ? this.getPaymentLink() : ""
                    }
                    readOnly
                    placeholder="Save your details above to generate a payment link"
                  />
                  <button
                    type="button"
                    style={{
                      ...styles.copyBtn,
                      opacity: this.state.hostedCatalogId ? 1 : 0.4,
                      cursor: this.state.hostedCatalogId
                        ? "pointer"
                        : "not-allowed",
                    }}
                    onClick={() => this.copyLinkToClipboard()}
                    disabled={!this.state.hostedCatalogId}
                  >
                    <i className="fa fa-copy" /> Copy
                  </button>
                  <button
                    type="button"
                    style={{
                      ...styles.copyBtn,
                      opacity: this.state.hostedCatalogId ? 1 : 0.4,
                      cursor: this.state.hostedCatalogId
                        ? "pointer"
                        : "not-allowed",
                    }}
                    onClick={() =>
                      this.state.hostedCatalogId &&
                      window.open(this.getPaymentLink(), "_blank")
                    }
                    disabled={!this.state.hostedCatalogId}
                  >
                    <i className="fa fa-external-link" /> Open
                  </button>
                </div>
              </div>

              {/* Button Code Card */}
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div
                    style={{
                      ...styles.cardHeaderIcon,
                      background:
                        "linear-gradient(135deg, color-mix(in srgb, #10b981 15%, transparent), color-mix(in srgb, #10b981 5%, transparent))",
                      color: "#10b981",
                    }}
                  >
                    <i className="mdi mdi-code-tags" />
                  </div>
                  <h4 style={styles.cardHeaderTitle}>Button Code</h4>
                </div>
                <div style={styles.cardBody}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label style={{ ...styles.label, margin: 0 }}>
                      Generated HTML Code
                    </label>
                    <button
                      type="button"
                      style={styles.copyBtn}
                      onClick={() => this.copyCodeToClipboard()}
                    >
                      <i className="fa fa-copy" /> Copy Code
                    </button>
                  </div>

                  <div style={styles.tabContainer}>
                    <button
                      type="button"
                      style={
                        this.state.activeGenerateTab === "button"
                          ? styles.tabActive
                          : styles.tab
                      }
                      onClick={() =>
                        this.setState({ activeGenerateTab: "button" })
                      }
                    >
                      <i className="mdi mdi-gesture-tap-button" /> Button
                    </button>
                    <button
                      type="button"
                      style={
                        this.state.activeGenerateTab === "qrcode"
                          ? styles.tabActive
                          : styles.tab
                      }
                      onClick={() =>
                        this.setState({ activeGenerateTab: "qrcode" })
                      }
                    >
                      <i className="mdi mdi-qrcode" /> QR Code
                    </button>
                    <button
                      type="button"
                      style={
                        this.state.activeGenerateTab === "hyperlink"
                          ? styles.tabActive
                          : styles.tab
                      }
                      onClick={() =>
                        this.setState({ activeGenerateTab: "hyperlink" })
                      }
                    >
                      <i className="mdi mdi-link" /> Hyperlink
                    </button>
                  </div>

                  <div style={styles.tabContent}>
                    {this.state.activeGenerateTab === "button" && (
                      <div>
                        <label
                          style={{
                            ...styles.label,
                            marginBottom: "10px",
                            display: "block",
                          }}
                        >
                          Select Button Size
                        </label>
                        <div style={styles.buttonSizeOptions}>
                          <button
                            type="button"
                            style={
                              this.state.selectedButtonSize === "small"
                                ? styles.sizeBtnActive
                                : styles.sizeBtn
                            }
                            onClick={() => this.handleGenerateButton("small")}
                          >
                            <i
                              className="mdi mdi-checkbox-blank-outline"
                              style={{ fontSize: "11px" }}
                            />{" "}
                            80 x 43 px
                          </button>
                          <button
                            type="button"
                            style={
                              this.state.selectedButtonSize === "medium"
                                ? styles.sizeBtnActive
                                : styles.sizeBtn
                            }
                            onClick={() => this.handleGenerateButton("medium")}
                          >
                            <i
                              className="mdi mdi-checkbox-blank-outline"
                              style={{ fontSize: "13px" }}
                            />{" "}
                            105 x 56 px
                          </button>
                          <button
                            type="button"
                            style={
                              this.state.selectedButtonSize === "large"
                                ? styles.sizeBtnActive
                                : styles.sizeBtn
                            }
                            onClick={() => this.handleGenerateButton("large")}
                          >
                            <i
                              className="mdi mdi-checkbox-blank-outline"
                              style={{ fontSize: "15px" }}
                            />{" "}
                            132 x 70 px
                          </button>
                        </div>
                      </div>
                    )}
                    {this.state.activeGenerateTab === "qrcode" && (
                      <div style={{ textAlign: "center" }}>
                        <button
                          type="button"
                          style={{
                            ...styles.btnPrimary,
                            opacity: this.state.hostedCatalogId ? 1 : 0.5,
                            cursor: this.state.hostedCatalogId
                              ? "pointer"
                              : "not-allowed",
                          }}
                          onClick={() => this.generateQrCode()}
                          disabled={!this.state.hostedCatalogId}
                        >
                          <i className="mdi mdi-qrcode" /> Generate QR Code
                        </button>
                      </div>
                    )}
                    {this.state.activeGenerateTab === "hyperlink" && (
                      <div style={{ textAlign: "center" }}>
                        <button
                          type="button"
                          style={{
                            ...styles.btnPrimary,
                            opacity: this.state.hostedCatalogId ? 1 : 0.5,
                            cursor: this.state.hostedCatalogId
                              ? "pointer"
                              : "not-allowed",
                          }}
                          onClick={() => this.generateHyperLink()}
                          disabled={!this.state.hostedCatalogId}
                        >
                          <i className="mdi mdi-link" /> Generate Hyperlink
                        </button>
                      </div>
                    )}
                  </div>

                  <div
                    style={{ ...styles.sectionDivider, margin: "20px 0 16px" }}
                  />

                  <div
                    style={{
                      fontSize: "12px",
                      color: "var(--text-color)",
                      opacity: 0.5,
                      marginBottom: "8px",
                    }}
                  >
                    Select all of the HTML code below, then copy and paste it
                    into your webpage.
                  </div>
                  <textarea
                    style={styles.codeArea}
                    ref={(textarea) => (this.textArea = textarea)}
                    value={this.state.buttonHtml}
                  />

                  <div
                    style={{ ...styles.sectionDivider, margin: "20px 0 16px" }}
                  />

                  <div>
                    <label
                      style={{
                        ...styles.label,
                        marginBottom: "10px",
                        display: "block",
                      }}
                    >
                      Preview
                    </label>
                    <div style={styles.previewBox}>
                      {!this.state.showPreviewForButton &&
                        !this.state.showPreviewForHyperlink &&
                        !this.state.showPreviewForQrCode && (
                          <span style={styles.previewPlaceholder}>
                            Select a tab above and generate to see the preview
                          </span>
                        )}
                      {this.state.showPreviewForButton && (
                        <div id="paynow_button_form_container">
                          <form
                            method="GET"
                            action={this.state.previewFormAction}
                            target="_blank"
                          >
                            <input
                              type="hidden"
                              name="hosted_catalog_id"
                              id="hosted_catalog_id"
                              value={this.state.encodedValue}
                            />
                            <table border="0">
                              <tbody>
                                <tr>
                                  <td align="center" valign="middle">
                                    <button
                                      type="submit"
                                      style={
                                        this.state.selectedButtonSize ===
                                        "small"
                                          ? {
                                              borderRadius: "4px",
                                              border: "solid #fff",
                                              background: "#102ab3",
                                              color: "#fff",
                                              width: "80px",
                                              height: "43px",
                                            }
                                          : this.state.selectedButtonSize ===
                                            "large"
                                          ? {
                                              borderRadius: "4px",
                                              border: "solid #fff",
                                              background: "#102ab3",
                                              color: "#fff",
                                              width: "132px",
                                              height: "70px",
                                            }
                                          : {
                                              borderRadius: "4px",
                                              border: "solid #fff",
                                              background: "#102ab3",
                                              color: "#fff",
                                              width: "105px",
                                              height: "56px",
                                            }
                                      }
                                    >
                                      <img
                                        src={
                                          this.assetDetailsForButtons(
                                            this.state.selectedAsset.assetId
                                          ).assetImage
                                        }
                                        style={
                                          this.state.selectedButtonSize ===
                                          "small"
                                            ? { width: "16px" }
                                            : this.state.selectedButtonSize ===
                                              "large"
                                            ? { width: "40px" }
                                            : { width: "33px" }
                                        }
                                      />{" "}
                                      <span
                                        style={
                                          this.state.selectedButtonSize ===
                                          "small"
                                            ? { fontSize: "10px" }
                                            : { fontSize: "12px" }
                                        }
                                      >
                                        Buy Now
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </form>
                        </div>
                      )}
                      {this.state.showPreviewForHyperlink && (
                        <div>
                          <a
                            target="_blank"
                            href={
                              PAYMENTURLFORHOSTEDCATALOG +
                              "?hosted_catalog_id=" +
                              btoa(this.state.hostedCatalogId)
                            }
                            style={{
                              color: "var(--btn-color)",
                              fontWeight: "600",
                              fontSize: "14px",
                            }}
                          >
                            Order Now
                          </a>
                        </div>
                      )}
                      {this.state.showPreviewForQrCode && (
                        <div id="qrCodeHtml">
                          <QRCodeSVG value={this.state.qrCodeLink} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default withRouter(EditHostedCatalogItem);
